import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import PaymentHistorialView from './PaymentHistorialView';
import { Creators as getPaymentsByPeriodActions } from '@/domain/useCases/payments/getPaymentsByPeriod/actions';
import { Creators as getPeriodsActions } from '@/domain/useCases/payments/getPaymentPeriods/actions';
import DateHelpers from '@/core/helpers/DateHelper';

const PaymentHistorialViewController: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [selectedPeriod, setSelectedPeriod] = useState({
    value: '',
    label: ''
  });

  const { data: periods, isLoading: periodsLoading } = useSelector(
    (state: any) => state.getPaymentPeriods
  );

  const { data: paymentsData, isLoading: paymentsLoading } = useSelector(
    (state: any) => state.getPaymentsByPeriod
  );

  const formattedPeriods = useMemo(() => {
    if (!periods) return [];
    return periods.map((period: any) => {
      const label = DateHelpers.periodToName(period.ciclolectivops);
      return {
        value: period.ciclolectivops,
        label
      };
    });
  }, [periods]);

  useEffect(() => {
    if (periods === undefined && !periodsLoading) {
      dispatch(getPeriodsActions.getPaymentPeriods());
    }
  }, [dispatch, periods, periodsLoading]);

  useEffect(() => {
    if (formattedPeriods.length > 0 && !selectedPeriod.value) {
      setSelectedPeriod(formattedPeriods[0]);
    }
  }, [formattedPeriods, selectedPeriod.value]);

  useEffect(() => {
    if (selectedPeriod?.value) {
      dispatch(
        getPaymentsByPeriodActions.getPaymentsByPeriod(selectedPeriod.value)
      );
    }
  }, [selectedPeriod.value]);

  const handleBack = () => {
    history.push('/pagos');
  };

  const handlePeriodChange = (item: any) => {
    setSelectedPeriod(item);
  };

  const isLoading = periodsLoading || paymentsLoading;

  return (
    <PaymentHistorialView
      periods={formattedPeriods}
      data={paymentsData?.paymentsByPeriod ?? []}
      dataLoading={isLoading}
      selectedPeriod={selectedPeriod}
      onPeriodChange={handlePeriodChange}
      handleBack={handleBack}
    />
  );
};

export default PaymentHistorialViewController;
